import React, { useEffect, useRef, useState } from "react"
import {
  ButtonWrapper,
  DisplayNameRowWrapper,
  DisplayNameWrapper,
  GlobeIconWrapper,
  InputWrapper,
  Unsaved,
  Update
} from "./DisplayNameInput.styled"
import ISO6391 from "iso-639-1"
import { DeleteButton } from "../../../Ui/Table/TableRow.styled"
import { DisplayName } from "lib/types/generated/graphql-types"
import { ReactComponent as GlobeIcon } from "../../../../images/icons/earth.svg"
import { ReactComponent as PenIcon } from "../../../../images/icons/pen-field.svg"
import { ReactComponent as UnsavedIcon } from "../../../../images/icons/floppy-disk-circle-xmark.svg"
import { ReactComponent as TrashIcon } from "images/icons/trash-can.svg"
import { ReactComponent as UpdateIcon } from "images/icons/arrows-repeat.svg"
import ActionButton from "../../../Ui/Table/ActionButton"
import Input from "../../../Ui/Form/Input"

type Props = {
  displayName: DisplayName
  savedDisplayNames?: DisplayName[]
  removeDisplayName: (key: string) => void
  updateTranslation: (languageCode: string, newTranslation: string) => void
}

const DisplayNameRow = ({
  displayName,
  savedDisplayNames,
  removeDisplayName,
  updateTranslation
}: Props) => {
  const [showEdit, setShowEdit] = useState(false)
  const [displayNameTranslation, setDisplayNameTranslation] = useState(displayName.translation)
  const isDisplayNameSaved = (key: string, value: string) =>
    savedDisplayNames?.find(
      (displayName) => displayName.languageCode === key && displayName.translation === value
    )

  const updateDisplayNameList = () => {
    updateTranslation(displayName.languageCode, displayNameTranslation)
    setShowEdit(false)
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault()
      if (displayNameTranslation !== displayName.translation) {
        updateDisplayNameList()
      }
    }
  }

  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (showEdit && inputRef.current) {
      inputRef.current.focus()
    }
  }, [showEdit])

  return (
    <DisplayNameRowWrapper>
      {savedDisplayNames &&
        !isDisplayNameSaved(displayName.languageCode, displayName.translation) && (
          <Unsaved
            data-tooltip-id={"unsaved"}
            data-tooltip-content={"Don’t forget to save to apply this change."}
          >
            <UnsavedIcon />
            Unsaved
          </Unsaved>
        )}
      <DisplayNameWrapper>
        <div>
          <GlobeIconWrapper>
            <GlobeIcon />
          </GlobeIconWrapper>
          <b>{`${ISO6391.getName(displayName.languageCode)} (${displayName.languageCode})`} </b>
        </div>
        {!showEdit && (
          <div>
            <PenIcon />
            {displayName.translation}
          </div>
        )}
        {showEdit && (
          <InputWrapper>
            <PenIcon />
            <Input
              name={"value"}
              ref={inputRef}
              defaultValue={displayName.translation}
              onKeyDown={handleKeyDown}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setDisplayNameTranslation(e.target.value)
              }
            />
            <Update onClick={updateDisplayNameList}>
              <UpdateIcon />
            </Update>
          </InputWrapper>
        )}
      </DisplayNameWrapper>
      <ButtonWrapper>
        <ActionButton
          mode="edit"
          handleOnClick={() => {
            setShowEdit(!showEdit)
          }}
        />
        <DeleteButton onClick={() => removeDisplayName(displayName.languageCode)}>
          <TrashIcon />
        </DeleteButton>
      </ButtonWrapper>
    </DisplayNameRowWrapper>
  )
}

export default DisplayNameRow
